
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2206"}},[_c('path',{attrs:{"data-name":"Rectangle 2931","fill":"none","d":"M0 0h125v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1329","d":"M125 50.908L97.495 23.403a9.969 9.969 0 00-7.495-3.4H22a10.009 10.009 0 00-10 10v40a9.951 9.951 0 002.505 6.6l11.4 11.4H24a6 6 0 00-4.242 10.243l21.758 21.757H125z","fill":"#727272"}}),_c('g',{attrs:{"data-name":"Group 2205","fill":"#d5d5d5"}},[_c('path',{attrs:{"data-name":"Path 1330","d":"M88 100H24a6 6 0 010-12h64a6 6 0 010 12z"}}),_c('path',{attrs:{"data-name":"Path 1331","d":"M90 80H22a10.009 10.009 0 01-10-10V30a10.009 10.009 0 0110-10h68a10.009 10.009 0 0110 10v40a10.009 10.009 0 01-10 10zm-2-45a3.009 3.009 0 00-3-3H27a3.009 3.009 0 00-3 3v30a3 3 0 003 3h58a3 3 0 003-3z"}})])])])
          )
        }
      }
    